export default __webpack_public_path__ + "static/media/logo-white.83bf9144.png";